export function initLanguageSwitcher() {
  const switcher = document.querySelector('.po-lang-switcher');
  if (!switcher) return;

  const listArea = switcher.querySelector('.po-lang-switcher__list-area');

  switcher.addEventListener('click', (e) => {
    e.stopPropagation();
    switcher.classList.toggle('po-lang-switcher_active');
    listArea.classList.toggle('active');
  });

  document.addEventListener('click', () => {
    switcher.classList.remove('po-lang-switcher_active');
    listArea.classList.remove('active');
  });
}
